/* eslint-disable no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as Constant from '../../constants/actionTypes';
// import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as MyBenefits } from '../../assets/icons/myBenefits.svg';
import { ReactComponent as Card } from '../../assets/icons/card.svg';

import { ReactComponent as Provider } from '../../assets/icons/provider.svg';
import { ReactComponent as MyHealthSummary } from '../../assets/icons/myHealthSummary.svg';

import { ReactComponent as TimeTracker } from '../../assets/icons/TimeTracker.svg';
import { ReactComponent as SendToAgency } from '../../assets/icons/send.svg';

export const Icon = props => {
  switch (props.name) {
    case props.name:
      return <props.name {...props} />;
    default:
      return <div />;
  }
};

Icon.propTypes = {
  name: PropTypes.object.isRequired,
};

export const labelName = name => {
  return <FormattedMessage id={name} />;
};

export const capitalizeSecondLetter = string => {
  return string.charAt(0) + string.charAt(1).toUpperCase() + string.slice(2);
};

export const onAddInertToDrawer = (selector, action) => {
  const divElement = document.getElementById(selector);
  if (action === 'add') {
    divElement?.setAttribute('inert', '');
  } else {
    divElement?.removeAttribute('inert');
  }
};

export const firstLowerLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};

export const getDateTimeValidated = dateTimeParam => {
  const invalidDateTimeStr = '---';

  if (
    dateTimeParam === null ||
    dateTimeParam === undefined ||
    dateTimeParam === '' ||
    dateTimeParam.length < 25
  )
    return invalidDateTimeStr;

  const currentDate = new Date(dateTimeParam);
  if (currentDate.toString() === 'Invalid Date') return invalidDateTimeStr;

  return currentDate;
};

export const getEffectiveDate = dateTimeParam => {
  const invalidDateTimeStr = '---';

  // eslint-disable-next-line no-useless-escape
  const mmddyyyyPattern = /(\d{1,})[-\/](\d{1,})[-\/](\d{4})/;
  // eslint-disable-next-line no-useless-escape
  const yyyymmddPattern = /(\d{4})[-\/](\d{1,})[-\/](\d{1,})/;
  let formattedDate;
  try {
    if (dateTimeParam === null || dateTimeParam === undefined || dateTimeParam === '')
      return invalidDateTimeStr;

    const mmddyyyyDate = mmddyyyyPattern.exec(dateTimeParam);
    const yyyymmddDate = yyyymmddPattern.exec(dateTimeParam);

    const trimmedDate = mmddyyyyDate ?? yyyymmddDate;

    const currentDate = new Date(trimmedDate[0]);
    if (currentDate.toString() === Constant.INVALID_DATE) return invalidDateTimeStr;

    if (mmddyyyyDate) formattedDate = `${mmddyyyyDate[1]}/${mmddyyyyDate[2]}/${mmddyyyyDate[3]}`;
    else if (yyyymmddDate)
      formattedDate = `${yyyymmddDate[2]}/${yyyymmddDate[3]}/${yyyymmddDate[1]}`;
    return formattedDate;
  } catch (err) {
    return invalidDateTimeStr;
  }
};

export const LongNameHandler = (FirstName, LastName) => {
  const NameLength = FirstName.length + LastName.length;
  let fontSize = Constant.SIXTEEN;
  let lName = null;
  let fName = null;
  const Name = FirstName.concat(' ', LastName);
  if (NameLength <= Constant.TWENTY_FIVE) {
    fontSize = Constant.SIXTEEN;
  } else if (NameLength > Constant.TWENTY_FIVE && NameLength <= Constant.THIRTY_TWO) {
    fontSize = Constant.TWELVE;
  } else if (NameLength > Constant.THIRTY_TWO && NameLength <= Constant.FOURTY) {
    fontSize = Constant.NINE_AND_HALF;
  } else if (NameLength > Constant.FOURTY) {
    fontSize = Constant.FIFTEN;
    fName = FirstName;
    lName = LastName;
    if (fName.length > Constant.TWENTY_FIVE) {
      fontSize = Constant.NINE_AND_HALF;
    }
    if (lName.length > Constant.TWENTY_FIVE) {
      fontSize = Constant.NINE_AND_HALF;
    }
  }
  return { fontSize, fName, lName, Name };
};

export const IconSelector = (IconName, style) => {
  switch (IconName) {
    case Constant.TIME_TRACKER_LINK:
      return <Icon name={TimeTracker} className={style} />;
    case Constant.MY_BENEFITS_LINK:
      return <Icon name={MyBenefits} className={style} />;
    case Constant.PROVIDER_SEARCH_LINK:
      return <Icon name={Provider} className={style} />;
    case Constant.SEND_TO_AGENCY_LINK:
      return <Icon name={SendToAgency} className={style} />;
    case Constant.DIGITAL_CARD_LINK:
      return <Icon name={Card} className={style} />;
    case Constant.MY_HEALTH_SUMMARY_LINK:
      return <Icon name={MyHealthSummary} className={style} />;
    default:
      return null;
  }
};
